module.exports = __webpack_public_path__ + "static/media/footer__linkedin.15287c05.svg";